<p-sidebar [visible]="isVisibleFilters()" position="right" [modal]="false" [showCloseIcon]="false" [transitionOptions]="'200ms'">
  <div class="filter_content">
    <div class="flex flex-between" style="align-items: unset!important; flex-direction: row; width: 100%; padding: 16px 16px 12px 16px; border-bottom: 1px solid #E5E5E5">
      <div class="filter_name" style="margin-right: auto;">
        Фільтр
      </div>
      <div style="margin-left: auto" class="flex-between flex">
        <div style="margin-right: 16px"><med-icon-refresh [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="filter.resetFilter('/basket')"></med-icon-refresh></div>
        <div><med-icon-close [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="this.filter.basketFilter = false"></med-icon-close></div>
      </div>
    </div>
    <div style="width: 100%; padding-left: 16px; padding-right: 25px">
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="МНН ID"
          label="МНН ID"
          [(ngModel)]="filter.basket.mnnId[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="МНН"
          label="МНН"
          [(ngModel)]="filter.basket.mnn[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Дозування"
          label="Дозування"
          [(ngModel)]="filter.basket.dosage[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Торгова назва"
          label="Торгова назва"
          [(ngModel)]="filter.basket.tradeName[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Серія"
          label="Серія"
          [(ngModel)]="filter.basket.series[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Кількість"
          label="Кількість"
          [(ngModel)]="filter.basket.quantity[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Ціна"
          label="Ціна"
          [(ngModel)]="filter.basket.price[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Загальна сума"
          label="Загальна сума"
          [(ngModel)]="filter.basket.totalPrice[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Статус"
          label="Статус"
          [(ngModel)]="filter.basket.status[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Відмова"
          label="Відмова"
          [(ngModel)]="filter.basket.refusal[0]"
          (focusout)="filter.basketStateChanged()"
        ></med-input>
      </div>
    </div>
  </div>
</p-sidebar>

<div class="flex flex-center flex-between">
    <app-page-title></app-page-title>
  <med-switch label="Показати товари того ж напряму" [(ngModel)]="showTheSameGoodsTable"></med-switch>&nbsp;&nbsp;
  <med-btn skin="red" class="med-btn red" (click)="clearBasket()" [disabled]="tableBody.length === 0">
        Очистити корзину
    </med-btn>
</div>

<div class="table-wrapper" style="height: 40vh">
    <p-table
            styleClass="p-datatable-sm"
            [scrollable]="true"
            scrollHeight="flex"
            [value]="tableBody"
            [tableStyle]="{ 'min-width': '50rem' }"
            [customSort]="true"
            [lazy]="true"
            [resizableColumns]="true"
            columnResizeMode="expand"
            [columns]="tabHeader"
            [reorderableColumns]="true"
            (onLazyLoad)="loadData()"
            (onColReorder)="saveColumnOrder()">
        <ng-template pTemplate="header">
            <tr>
                <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeader" style="min-width: 10em" pReorderableColumn pResizableColumn>
                    <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'min-width': '5em'}">
                        {{ column.label }}&nbsp;
                        <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
                    </div>
                </th>
                <th>

                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-columns="columns">
            <tr class="table-content-text">
                <ng-container *ngFor="let col of columns">
                <td class="h10-text black-80" *ngIf="col.key === 'mnnId'">
                    {{row['good']['mnnId']}}
                </td>
                <td class="h10-text black-80" *ngIf="col.key === 'mnnName'">
                    <div class="flex-12rem">
                        <span class="truncate-text">
                            {{row['good']['mnnName']}}
                        </span>
                    </div>
                </td>
                <td class="h10-text black-60" *ngIf="col.key === 'dosage'">
                    <div class="flex-12rem">
                        <span class="truncate-text">
                            {{row['good']['dosage']}}
                        </span>
                    </div>
                </td>
                <td class="h10-text black-80" *ngIf="col.key === 'tradeName'">
                    <div class="flex-12rem">
                        <span class="truncate-text">
                            {{row['good']['tradeName']}}
                        </span>
                    </div>
                </td>
                <td class="h10-text black-80" *ngIf="col.key === '5'">
                    {{row['seriesCatalogue']}}
                </td>
                <td class="h10-text black-80" *ngIf="col.key === 'quantity'">
                    {{row['extra']['availableForDistribution']}}
                </td>
                <td class="h10-text black-80" *ngIf="col.key === 'unitPrice'">
                    {{row['adjUnitPrice']}}
                </td>
                <td class="h10-text black-80" *ngIf="col.key === 'totalPrice'">
                    {{getRowSum(row['extra']['availableForDistribution'], row['adjUnitPrice'])}}
                </td>
                  <td class="h10-text black-80" *ngIf="col.key === '9'">

                  </td>
                  <td *ngIf="col.key === '10'">
                    <img [src]="getStatusImgPath(row['refusal'])" width="4" height="16" style="vertical-align: middle;"/>
                    <span>{{ row['extra']['refusal'] ? ' Так' : ' Ні' }}</span>
                  </td>
                </ng-container>
              <td>
                <med-icon-delete [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (mouseenter)="deletePanel.show($event)" (mouseleave)="deletePanel.hide()"
                                 (click)="deleteItem(row['specificationId'])"></med-icon-delete>
                <p-overlayPanel #deletePanel>
                  <div class="flex items-center h10-text">
                    Олексій
                  </div>
                </p-overlayPanel>
              </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div class="text-h6-heading black-80 mt-3" *ngIf="showTheSameGoodsTable">
  Tовари такого ж напрямку на складі ({{tableBodyAdditionalGoods.length}})
</div>

<div class="table-wrapper" *ngIf="showTheSameGoodsTable" style="height: 40vh">
  <p-table
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="tableBodyAdditionalGoods"
    [tableStyle]="{ 'min-width': '50rem' }"
    [customSort]="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [columns]="tabHeader"
    [reorderableColumns]="true"
    (onLazyLoad)="additionalGoodsChanged()"
    (onColReorder)="saveColumnOrder()">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeader" style="min-width: 10em" pReorderableColumn pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'min-width': '5em'}">
            {{ column.label }}&nbsp;
            <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
          </div>
        </th>
        <th>

        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-columns="columns">
      <tr class="table-content-text">
        <td>
          <med-checkbox size="small"  *ngIf="'MZU' === dataService.userRoleValue.getValue()"
                        (change)="onChangeHandlerSpecification(row)"
                        [value]="basketService.containsAlreadySpecification(row.specificationId)"
                        [disabled]="basketService.hasTheDifferentDirection(row.good.direction.id) || basketService.hasTheDifferentWarehouse(row.warehouseName)"></med-checkbox>
        </td>
        <ng-container *ngFor="let col of columns">
          <td class="h10-text black-80" *ngIf="col.key === 'mnnId'">
            {{row['good']['mnnId']}}
          </td>
          <td class="h10-text black-80" *ngIf="col.key === 'mnnName'">
            <div class="flex-12rem">
                        <span class="truncate-text">
                            {{row['good']['mnnName']}}
                        </span>
            </div>
          </td>
          <td class="h10-text black-60" *ngIf="col.key === 'dosage'">
            <div class="flex-12rem">
                        <span class="truncate-text">
                            {{row['good']['dosage']}}
                        </span>
            </div>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === 'tradeName'">
            <div class="flex-12rem">
                        <span class="truncate-text">
                            {{row['good']['tradeName']}}
                        </span>
            </div>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '5'">
            {{row['seriesCatalogue']}}
          </td>
          <td class="h10-text black-80" *ngIf="col.key === 'quantity'">
            {{row['extra']['availableForDistribution']}}
          </td>
          <td class="h10-text black-80" *ngIf="col.key === 'unitPrice'">
            {{row['adjUnitPrice']}}
          </td>
          <td class="h10-text black-80" *ngIf="col.key === 'totalPrice'">
            {{getRowSum(row['extra']['availableForDistribution'], row['adjUnitPrice'])}}
          </td>
<!--          <td class="h10-text black-80" *ngIf="col.key === 'status'">-->
<!--            Test-->
<!--          </td>-->
          <td class="h10-text black-80" *ngIf="col.key === '9'">

          </td>
          <td *ngIf="col.key === '10'">
            <img [src]="getStatusImgPath(row['refusal'])" width="4" height="16" style="vertical-align: middle;"/>
            <span>{{ row['extra']['refusal'] ? ' Так' : ' Ні' }}</span>
          </td>
        </ng-container>
        <td>
          <med-icon-delete [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (mouseenter)="deletePanel.show($event)" (mouseleave)="deletePanel.hide()"
                           (click)="deleteItem(row['specificationId'])"></med-icon-delete>
          <p-overlayPanel #deletePanel>
            <div class="flex items-center h10-text">
              Олексій
            </div>
          </p-overlayPanel>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div style="margin-top: 1em" class="grid nested-grid">
    <med-card class="sign-status-card radius-8px" style="width: 100%">
        <div class="flex flex-center mb-4">
            <med-icon-aimbulance
                    size="36"
                    mode="square"
            ></med-icon-aimbulance>

            <h6 class="text extra-large ml-2 mb-0 mt-0">
                Дані для розподілу
            </h6>
        </div>

        <div class="col-12">
        <div class="grid">
        <div class="col-8" style="padding-left: unset">
            <div class="col-6 column-placement"  style="border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 100%; width: 100%">
                <div class="black-80 h8-text">Оберіть тип розподілу:</div>
                <div class="mt-2 row wrap">
                    <med-radio-group [options]="options" [value]="value" (onInput)="distrTypeChanged($event)"></med-radio-group>
                </div>
            </div>
        </div>

        <div class="col-4">
            <div class="col-6 column-placement" style="border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 100%; width: 100%">
                <div class="flex flex-center flex-between h10-text black-80">
                    <span title>Кількість позицій:</span>
                    <span title>{{tableBody.length}}</span>
                </div>
                <div class="flex flex-center flex-between h10-text black-80 mt-1">
                    <span title>Кількість одиниць товару:</span>
                    <span title>{{getTotalQuantity()}}</span>
                </div>
                <div class="flex flex-center flex-between h10-text black-80 mt-1">
                    <span title>Загальна сума товарів:</span>
                    <span title>{{getTotalSum()}}</span>
                </div>
                <div class="flex flex-center flex-between h10-text black-80 mt-1">
                    <span title>Назва складу:</span>
                    <span title>{{getWarehouseName()}}</span>
                </div>
                <div class="flex flex-center flex-between h10-text black-80 mt-1">
                    <span title>Напрям:</span>
                    <span title class="truncate-15em" [pTooltip]="tooltipContent">{{getDirectionName()}}</span>
                    <ng-template #tooltipContent>
                        <div class="flex items-center h10-text">
                            {{getDirectionName()}}
                        </div>
                    </ng-template>
                </div>
                <div class="mt-1" style="width: 100%;">
                    <med-btn class="btn-100" (click)="showModal()" [disabled]="tableBody.length === 0 || loading">
                        Почати розподіл
                        &nbsp;
                        <med-icon-arrow-right [ngStyle]="{'width': '16px'}" *ngIf="!loading"></med-icon-arrow-right>
                      <med-icon-sync
                        *ngIf="loading"
                        size="20"
                        class="animate--rotate mr-2"
                      ></med-icon-sync>
                    </med-btn>
                </div>
            </div>
        </div>
        </div>
        </div>
    </med-card>
</div>

<med-modal
        [(visible)]="visible"
>
    <div class="em-25">
    <div class="flex justify-content-center">
        <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>
    </div>
    <div class="text-h6-heading mt-3">
        Ви впевнені, що бажаєте почати розподіл?
    </div>
    <div class="text-h10-center mt-3">
        Після цього повернення до корзини та зміна режиму буде неможливою.
    </div>
    <div class="mt-4">
        <div class="mt-1">
        <med-btn (click)="visible = false; goToDistribution()" [disabled]="loading">
          <med-icon-sync
            *ngIf="loading"
            size="20"
            class="animate--rotate mr-2"
          ></med-icon-sync>
          Почати розподіл
        </med-btn>
        </div>
        <div class="mt-1">
        <med-btn skin="gray" (click)="visible = false">Скасувати</med-btn>
        </div>
    </div>
    </div>
</med-modal>
